import styled from 'styled-components'

export const GlobalStyledContainer = styled.div`
  color: var(--typography500);
  background-color: var(--neutral-theme);

  touch-action: pan-y;
  overflow-y: auto;
  -webkit-user-drag: none;

  -webkit-user-select: none;
  user-select: none;
  &::selection {
    background-color: var(--neutral-theme);
  }
`
